import { getURLParams } from 'js/utils/url.util';
import { FB_PARAMS_TO_REMOVE } from './constants';

export const renameKeys = newKeys => obj => Object
    .keys(obj)
    .reduce((acc, key) => ({
        ...acc,
        ...{ [newKeys[key] || key]: obj[key] }
    }), {});

export const prepareBirthdate = (birthday) => {
    if (!birthday) {
        return birthday;
    }

    const [month, day, year] = birthday.split('/');

    return [year, month, day].join('-');
};

export const prepareGender = gender => gender ? gender[0].toUpperCase() : gender;

export const makeFbLink = (clientID, currentPage) => {
    const linkPrefix = 'https://www.facebook.com/v6.0/dialog/oauth?client_id=';
    const linkSuffix = '&scope=email%2Cuser_gender%2Cuser_birthday%2Cuser_location&state=hub2_facebook_registration';

    return `${linkPrefix}${clientID}&redirect_uri=${currentPage}${linkSuffix}`;
};

export const makeGraphLink = (accessToken) => {
    const urlPrefix = 'https://graph.facebook.com/v6.0/me/?access_token=';
    const urlSuffix = '&fields=first_name,last_name,email,gender,birthday,location{location{country_code,city,region}}';

    return `${urlPrefix}${accessToken}${urlSuffix}`;
};

export const getPlayerAcceptedCode = () => {
    const { code, state } = getURLParams(window.location.search);

    return state === 'hub2_facebook_registration' && code ? code : '';
};

export const getCleanUrl = () => {
    const url = new window.URL(window.location.href);

    if (FB_PARAMS_TO_REMOVE.some(prop => url.searchParams.has(prop))) {
        FB_PARAMS_TO_REMOVE.forEach(prop => url.searchParams.delete(prop));
    }

    // Facebook adds #_=_ to the redirect_uri when hash is left blank
    if (url.hash === '#_=_') {
        url.hash = '';
    }

    return url.toString();
};
